export function getPreviousMonthAndYear(date) {
  const year = date.getFullYear(date);
  const month = date.getMonth(date);
  const prevMonth = month === 0 ? 11 : month - 1;
  const prevYear = month === 0 ? year - 1 : year;
  return { prevMonth, prevYear };
}